import type { PendingIncomeRow } from '@econtractor/types';
import PendingIncomeTableRow from './PendingIncomeTableRow';

interface PendingIncomeTableBodyProps {
    rows: PendingIncomeRow[];
    canAct: boolean;
    selected: number[];
    saving: boolean;
    onToggle: (operationId: number) => void;
    onAcceptAll: (operationId: number) => void;
    onAcceptPartial: (row: PendingIncomeRow) => void;
}

const PendingIncomeTableBody = ({
    rows,
    canAct,
    selected,
    saving,
    onToggle,
    onAcceptAll,
    onAcceptPartial,
}: PendingIncomeTableBodyProps) => (
    <tbody>
        {rows.map((row) => (
            <PendingIncomeTableRow
                key={row.ID}
                row={row}
                canAct={canAct}
                checked={selected.includes(row.ID)}
                saving={saving}
                onToggle={onToggle}
                onAcceptAll={onAcceptAll}
                onAcceptPartial={onAcceptPartial}
            />
        ))}
    </tbody>
);

export default PendingIncomeTableBody;
